<template>
    <ul class="header-menu-list">
        <li
            v-for="(menuItem, menuIndex) in mainMenu"
            :key="menuIndex"
        >
            <HeaderLink :link="menuItem.link">
                {{ menuItem.title }}
            </HeaderLink>

            <ul v-if="menuItem.subMenu?.sections">
                <li
                    v-for="(section, sectionIndex) in menuItem.subMenu.sections"
                    :key="sectionIndex"
                >
                    <span v-if="section.title">
                        {{ section.title }}
                    </span>

                    <HeaderLink
                        v-for="(item, index) in section.items"
                        :key="index"
                        :link="item.link"
                    >
                        {{ item.title }}
                    </HeaderLink>
                </li>
            </ul>

            <HeaderLink
                v-if="menuItem.subMenu?.editorialContent"
                :link="menuItem.subMenu.editorialContent.link"
            >
                {{ menuItem.subMenu.editorialContent.text }}
            </HeaderLink>
        </li>
    </ul>
</template>

<script setup lang="ts">
import type { HeaderMenuFragment } from '@/graphql/api'

import HeaderLink from './HeaderLink.vue'

defineProps<{
    mainMenu: HeaderMenuFragment[]
}>()
</script>

<style lang="scss" scoped>
.header-menu-list {
    display: none;
}
</style>
